"use strict";
exports.__esModule = true;
exports.VARIANT = exports.SEVERITY = void 0;
exports.SEVERITY = {
    danger: 'bg-danger border-danger text-danger-dark',
    warning: 'bg-warning border-warning text-warning-dark',
    success: 'bg-success border-success text-success-dark',
    info: 'bg-info border-info text-info-dark'
};
exports.VARIANT = {
    filled: 'border-none text-white',
    outlined: 'bg-white border-2'
};
//# sourceMappingURL=alert.style.js.map